<template>
  <div>
    <v-navigation-drawer
      :value="isOpenDateStatsDetails"
      :permanent="isOpenDateStatsDetails"
      width="40vw"
      max-width="100vw"
      right
      fixed
      temporary
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
    >
      <v-card min-height="100vh" color="grey lighten-3">
        <BaseToolbar
          :button-save="false"
          @close="close"
          :title="name"
          type-title="icon"
        />
        <v-card-text style="overflow-y: auto; height: calc(100vh - 64px)">
          <v-container class="pa-5">
            <v-data-table
              :headers="headers"
              :items="dateStats"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t("afrus_engine.table.header_org")
                  }}</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div class="d-flex justify-center">
                  <v-chip
                    color="blue"
                    class="white--text"
                    style="
                      width: 90px;
                      display: flex;
                      justify-content: center;
                      max-width: 130px;
                      font-weight: 600;
                    "
                  >
                    {{ item.date }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.effective`]="{ item }">
                <div class="d-flex justify-center">{{ item.effective }}</div>
              </template>
              <template v-slot:[`item.failed`]="{ item }">
                <div class="d-flex justify-center">{{ item.failed }}</div>
              </template>
              <template v-slot:[`item.scheduled`]="{ item }">
                <div class="d-flex justify-center">{{ item.scheduled }}</div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import VueJsonPretty from "vue-json-pretty";
import BaseToolbar from "@/components/BaseToolbar";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "DateDetails",
  components: { BaseToolbar, VueJsonPretty },
  props: ['name'],
  data() {
    return {
      panel: [0],
      headers: [
        {
          text: this.$t("afrus_engine.table.date"),
          align: "center",
          sortable: false,
          value: "date",
          class: "text-no-wrap blue--text text--darken-4",
          width: "25%",
        },
        {
          text: this.$t("afrus_engine.table.effective"),
          value: "effective",
          width: "25%",
          align: "center",
          class: "text-no-wrap blue--text text--darken-4",
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.failed"),
          value: "failed",
          width: "25%",
          align: "center",
          class: "text-no-wrap blue--text text--darken-4",
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.scheduled"),
          value: "scheduled",
          width: "25%",
          align: "center",
          class: "text-no-wrap blue--text text--darken-4",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      dateStats: "afrusEngine/dateStats",
      isOpenDateStatsDetails: "afrusEngine/isOpenDateStatsDetails",
    }),
  },
  methods: {
    ...mapMutations({
      setIsOpenDateStatsDetails: "afrusEngine/setIsOpenDateStatsDetails",
    }),
    close() {
      this.setIsOpenDateStatsDetails(false);
    },
  },
};
</script>

<style></style>
